// extracted by mini-css-extract-plugin
export default {"officialPastItem":"index_officialPastItem__JwH-Q","pastDrawerListWrap":"index_pastDrawerListWrap__LlAlJ"};